module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Clifford A. Pickover\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Clifford A. Pickover, a research staff member at IBM’s T. J. Watson Research Center, is an authority on the interface of science, art, mathematics, computing, and the visual modeling of data. He is the author of such highly regarded books as "), _c('I', [_vm._v("Black Holes: A Traveler’s Guide")]), _vm._v(", "), _c('I', [_vm._v("The Alien IQ Test")]), _vm._v(", and "), _c('I', [_vm._v("Chaos in Wonderland: Visual Adventures in a Fractal World")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Cfw03b/tc-custom/9781402797491.jpg?1705231662477",
      "alt": "This image is the cover for the book Math Book, Union Square & Co. Milestones"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Math Book, Union Square & Co. Milestones\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The Neumann Prize–winning, illustrated exploration of mathematics—from its timeless mysteries to its history of mind-boggling discoveries. ")]), _c('br'), _c('br'), _vm._v("Beginning millions of years ago with ancient “ant odometers” and moving through time to our modern-day quest for new dimensions, "), _c('i', [_vm._v("The Math Book")]), _vm._v(" covers 250 milestones in mathematical history. Among the numerous delights readers will learn about as they dip into this inviting anthology: cicada-generated prime numbers, magic squares from centuries ago, the discovery of pi and calculus, and the butterfly effect. Each topic is lavishly illustrated with colorful art, along with formulas and concepts, fascinating facts about scientists’ lives, and real-world applications of the theorems.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Sterling Publishing Co., Inc\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0